import { LoginForm } from '@/features/auth';
import { setPageTitle } from '@/lib/utils';

export function LoginPage() {
  setPageTitle('Login');
  return <LoginForm />;
}
